export class Tenant {
	constructor({ tenantId, name, shortCode, settings } = {}) {
		this.tenantId = tenantId;
		this.name = name;
		this.shortCode = shortCode;
		this.settings = new TenantSettings(settings);
	}
}

export class TenantSettings {
	constructor({
		brandImages = new TenantBrandImages(),
		brandName = 'Locumbase',
		brandUrl = 'https://www.locumbase.com',
		brandYoutubeUrl = '',
		brandAdvertImageLeft = '',
		brandAdvertImageRight = '',
		theme = new TenantTheme(),
		wallet = new Wallet(),
		pricing = new Pricing(),
	} = {}) {
		this.brandImages = new TenantBrandImages(brandImages);
		this.brandName = brandName;
		this.brandUrl = brandUrl;
		this.brandYoutubeUrl = brandYoutubeUrl;
		this.brandAdvertImageLeft = brandAdvertImageLeft;
		this.brandAdvertImageRight = brandAdvertImageRight;
		this.theme = new TenantTheme(theme);
		this.wallet = new Wallet(wallet);
		this.pricing = new Pricing(pricing);
	}
}

export class TenantTheme {
	constructor({
		primary = '#FF5F05', //Orange
		secondary = '#4D88A1', //Cyan
		accent = '#009CEF', // Blue
		error = '#F44336', //Red
		anchor = '#FF5F05',
		background = '#FFFFFF',
	} = {}) {
		this.primary = primary;
		this.secondary = secondary;
		this.accent = accent;
		this.error = error;
		this.anchor = anchor;
		this.background = background;
	}

	set(vuetify) {
		vuetify.framework.theme.themes.light.primary = this.primary;
		vuetify.framework.theme.themes.light.secondary = this.secondary;
		vuetify.framework.theme.themes.light.accent = this.accent;
		vuetify.framework.theme.themes.light.error = this.error;
		vuetify.framework.theme.themes.light.anchor = this.anchor;
		vuetify.framework.theme.themes.light.background = this.background;
	}
}

const iHeaderLogos = {
	app: {
		light: '',
		dark: '',
	},
	auth: {
		light: '',
		dark: '',
	},
};

const iDashboardImage = {
	company: '',
	professional: '',
};

export class TenantBrandImages {
	constructor({ headerLogos = iHeaderLogos, dashboardImage = iDashboardImage } = {}) {
		this.headerLogos = headerLogos;
		this.dashboardImage = dashboardImage;
	}
}

export class Wallet {
	constructor({ show = false } = {}) {
		this.show = show;
	}
}
export class Pricing {
	constructor({ show = false } = {}) {
		this.show = show;
	}
}

export default Tenant;
